import { Component } from '@angular/core';
import {NgIf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-hero-empresarial',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgIf
  ],
  templateUrl: './hero-empresarial.component.html',
  styleUrl: './hero-empresarial.component.css'
})
export class HeroEmpresarialComponent {

  name="";
  description = "";
  routeLogo = "assets/img/enterprise/preventivas.svg";
  routeImage = "assets/img/enterprise/bannerEmpresarial.svg"
  description2: any;
  protected readonly alert = alert;
}
